import React from "react";
import styles from "./FinancialsTab.module.css";

const StatCard = ({ icon, label, value, sub, variant = "primary", highlight = false, big = false }) => {
  return (
    <div
      className={`${styles.card} ${styles[variant]} ${highlight ? styles.highlight : ""} ${big ? styles.big : ""}`}
    >
      <div className={styles.cardIcon}>{icon}</div>
      <div className={styles.cardBody}>
        <span className={styles.cardLabel}>{label}</span>
        <span className={styles.cardValue}>{value}</span>
        {sub && <span className={styles.cardSub}>{sub}</span>}
      </div>
    </div>
  );
};

export default StatCard;